import {
    GET_SAVED_FILTERS_SUCCESS,
    SAVE_FILTER_SUCCESS,
    DELETE_FILTER_SUCCESS,
    SET_DEFAULT_FILTER_SUCCESS
} from '../actions/savedFilters';

const emptyScreen = { presets: [], defaultPreset: null };

export const SAVED_FILTERS_SCREENS = ['dashboard-global', 'dashboard-operations', 'dashboard-inventory'];

const initialState = {
    fetching: false,
    fetched: false,
    screens: SAVED_FILTERS_SCREENS.reduce((acc, screen) => {
        acc[screen] = { ...emptyScreen };
        return acc;
    }, {})
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SAVED_FILTERS_SUCCESS: {
            const screens = Object.keys(action.payload.screens).reduce((acc, screen) => {
                acc[screen] = { ...emptyScreen, ...action.payload.screens[screen] };
                return acc;
            }, {});

            return {
                ...state,
                fetched: true,
                screens: {
                    ...state.screens,
                    ...screens
                }
            };
        }
        case SAVE_FILTER_SUCCESS: {
            const { screen, presets } = action.payload;
            return {
                ...state,
                screens: {
                    ...state.screens,
                    [screen]: {
                        ...state.screens[screen],
                        presets
                    }
                }
            };
        }
        case DELETE_FILTER_SUCCESS: {
            const { screen, presets, defaultPreset } = action.payload;
            return {
                ...state,
                screens: {
                    ...state.screens,
                    [screen]: {
                        ...state.screens[screen],
                        presets,
                        defaultPreset
                    }
                }
            };
        }
        case SET_DEFAULT_FILTER_SUCCESS: {
            const { screen, defaultPreset } = action.payload;
            return {
                ...state,
                screens: {
                    ...state.screens,
                    [screen]: {
                        ...state.screens[screen],
                        defaultPreset
                    }
                }
            };
        }
        default:
            return state;
    }
};
